import { Action } from 'redux'

export enum MESSAGE_TYPES {
  info = 'info',
  warning = 'warning',
  alert = 'alert',
}

export interface IGlobalMessageCta {
  label: string
  action?: () => void
  url?: string
  target?: string
}

export interface IGlobalMessageOptions {
  type: MESSAGE_TYPES
  typeLabel?: string
  closeDelay?: number | null
  cta?: IGlobalMessageCta
  clickToCopyValue?: string
}

export interface IGlobalMessage extends IGlobalMessageOptions {
  id: string
  message: string
}

export interface IGlobalMessagingState {
  message?: IGlobalMessage
}

export interface IGlobalMessagingAction extends Action<string> {
  payload?: IGlobalMessage
}
